import { lazy, Suspense } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// guards
import AdminGuard from '../guards/AdminGuard';
// layouts
import AdminLayout from '../layouts/admin';
// components
import LoadingScreen from '../components/LoadingScreen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();

  return (
    <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/manage')} />}>
      <Component {...props} />
    </Suspense>
  );
};

// Lazy load admin pages
const AdminDashboard = Loadable(lazy(() => import('../pages/admin/AdminDashboard')));
const Brevo = Loadable(lazy(() => import('../pages/admin/Brevo')));
const EmailTest = Loadable(lazy(() => import('../pages/admin/EmailTest')));
const SocialCalendar = Loadable(lazy(() => import('../pages/admin/SocialCalendar')));
const APIKeys = Loadable(lazy(() => import('../pages/admin/APIKeys')));
const JobRequests = Loadable(lazy(() => import('../pages/admin/JobRequests')));
const ImageApproval = Loadable(lazy(() => import('../pages/admin/ImageApproval')));
const IngredientApproval = Loadable(lazy(() => import('../pages/admin/IngredientApproval')));
const ProManagement = Loadable(lazy(() => import('../pages/admin/ProManagement')));
const ProductsAdmin = Loadable(lazy(() => import('../pages/admin/Products')));
const ProductCreate = Loadable(lazy(() => import('../pages/admin/ProductCreate')));
const ProductEdit = Loadable(lazy(() => import('../pages/admin/ProductEdit')));
const OrderList = Loadable(lazy(() => import('../pages/admin/OrderList')));
const UserList = Loadable(lazy(() => import('../pages/admin/UserList')));
const UserCreate = Loadable(lazy(() => import('../pages/admin/UserCreate')));
const SystemDocs = Loadable(lazy(() => import('../pages/admin/SystemDocs')));
const TelegramManager = Loadable(lazy(() => import('../pages/admin/TelegramManager')));
const VarietyApproval = Loadable(lazy(() => import('../pages/admin/VarietyApproval')));

// ----------------------------------------------------------------------

export const adminRoutes = {
  path: 'manage',
  element: (
    <AdminGuard>
      <AdminLayout />
    </AdminGuard>
  ),
  children: [
    { element: <Navigate to="dashboard" replace />, index: true },
    { path: 'dashboard', element: <AdminDashboard /> },
    {
      path: 'users',
      children: [
        { element: <Navigate to="list" replace />, index: true },
        { path: 'list', element: <UserList /> },
        { path: 'new', element: <UserCreate /> },
        { path: ':name/edit', element: <UserCreate /> },
      ],
    },
    {
      path: 'products',
      children: [
        { element: <ProductsAdmin />, index: true },
        { path: 'new', element: <ProductCreate /> },
        { path: ':id/edit', element: <ProductEdit /> },
      ],
    },
    { path: 'orders', element: <OrderList /> },
    { path: 'brevo', element: <Brevo /> },
    { path: 'email-test', element: <EmailTest /> },
    { path: 'social', element: <SocialCalendar /> },
    { path: 'telegram', element: <TelegramManager /> },
    { path: 'api-keys', element: <APIKeys /> },
    { path: 'image-approval', element: <ImageApproval /> },
    { path: 'ingredient-approval', element: <IngredientApproval /> },
    { path: 'variety-approval', element: <VarietyApproval /> },
    { path: 'jobs', element: <JobRequests /> },
    { path: 'pro-management', element: <ProManagement /> },
    { path: 'system-docs', element: <SystemDocs /> },
  ],
};
